import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

let role = sessionStorage.getItem('role');
let pkUserId = sessionStorage.getItem('pkUserId');

export const getListOfCustomerById = (pk_customer_id,headers) => {
  return Axios.get(`getListOfCustomerById/${pk_customer_id}`, {
    headers,
  });
};

export const getDealerDetailsById = (pk_dealer_id,headers) => {
  return Axios.get(`getDealerDetailsById/${pk_dealer_id}`, {
    headers,
  });
};

// lets decide what to write here for all work orders  Service Engineer Name *{" "} dropdown

export const getListOfUserById = (pk_user_id,headers) => {
    // return Axios.get(`petrotec/getListOfUserById/${pk_user_id}`, {
  return Axios.get(`/User/${pk_user_id}`, {
    headers,
  });
};